// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class PaginationCountDisplay extends Component {
  #from: HTMLElement | null;
  #to: HTMLElement | null;
  #total: HTMLElement;

  /**
   * Initiate the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);
    this.setUp();

    this.addListener(Notifications.FILTERED, this.handle);
    this.addListener(Notifications.SORTED, this.handle);
    this.addListener(Notifications.PAGINATED, this.handle);
  }

  /**
   * Setup properties & validation
   */
  setUp(): void {
    this.#from = this.el.querySelector('[ref="from"]');
    this.#to = this.el.querySelector('[ref="to"]');

    const total = this.el.querySelector('[ref="total"]');
    if (total) {
      this.#total = total;
    } else {
      throw new Error('The total is required to update');
    }
  }

  /**
   * Handle the incoming notifications
   */
  handle(data: Object): void {
    this.updateInformation(data.data.pagination || data.data.productsData);
  }

  /**
   * Update the information
   */
  updateInformation(data: Object): void {
    if (this.#from) {
      this.#from.innerText = data.from || 0;
    }
    if (this.#to) {
      this.#to.innerText = data.to || 0;
    }
    this.#total.innerText = data.total;
  }
}
